import React from 'react';
import { connect } from 'react-redux';

import Icon from 'components/generic/Icon.component';
import ResponsiveBox from 'components/generic/ResponsiveBox.component';
import PURCHASE_VARIANTS from 'constants/sms/purchase.const';
import { useNavFor } from 'hooks/useNav.hook';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { selectClientCommsSmsCreditsAvailable } from 'selectors/clientCommunications.selectors';
import selectEffectiveUserRole from 'selectors/selectEffectiveUserRole';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';

import { purchaseSmsBundle } from 'clientCommunications/actions';
import PurchaseSmsCreditDialog from 'clientCommunications/components/Clients/PurchaseSmsCreditDialog';

import CN from './SmsBuyButton.module.scss';

const SmsBuyButton = ({ tag, purchaseSmsBundle, smsError, isSmsFetching, smsCredits, permission, history }) => {
  const salonId = useCurrentSalonId();
  const { t } = useTranslation();
  // eslint-disable-next-line no-unused-vars
  const nav = useNavFor('SmsBuyButton()');
  const { val: renderSmsModal, tip: toggleSmsModal } = useTip(false);

  return (
    <div className={CN.component} data-bem="SmsBuyButton" data-tag={fromAnyToTrimmed(tag)}>
      <div className={CN.button} data-bem="SmsBuyButton__button" onClick={toggleSmsModal}>
        <Icon variant="smsBubble" selected width="xl" />
        <ResponsiveBox.Desktop>
          <div className={CN.smsText}>
            {smsCredits} {t('composite.purchaseSmsCreditDialog.credits')}
          </div>
        </ResponsiveBox.Desktop>
      </div>
      {renderSmsModal && (
        <PurchaseSmsCreditDialog
          closePopup={toggleSmsModal}
          // FIXME
          // gotoBilling={() =>
          //   nav.push({
          //     pathname: linkTo({
          //       pattern: LINK.billing,
          //       salonId,
          //     }),
          //   })
          // }
          gotoBilling={() => {
            window.location.hash = `#/salon/${salonId}/settings/billing`;
          }}
          purchaseSmsBundle={purchaseSmsBundle}
          salonId={salonId}
          errorMessage={smsError}
          isFetching={isSmsFetching}
          sms_credits_available={smsCredits}
          permission={permission}
          variant={PURCHASE_VARIANTS.lowCredit}
          variantButton="lowCredit"
        />
      )}
    </div>
  );
};

const SmsBuyButtonHoc = connect(
  (state) => ({
    permission: selectEffectiveUserRole(state),
    smsCredits: selectClientCommsSmsCreditsAvailable(state),
    smsError: state.clientCommunications.errorMessage,
    isSmsFetching: state.clientCommunications.isFetching,
  }),
  mapActionsToDispatchToProps({
    purchaseSmsBundle,
  }),
)(SmsBuyButton);

export default SmsBuyButtonHoc;
